import React from "react";
import { motion } from "framer-motion";
import backend from "../images/backend.gif";
import frontend from "../images/frontend.gif";
import skills from "../images/miscellaneous.gif"

const Skills = () => {
  return (
    <section
      id="#skills"
      className="max-w-7xl py-6 xxl:py-16 mx-auto w-full px-6"
    >
      <div className="md:flex flex-col gap-3 justify-center">
        <motion.h1
          whileInView={{ y: 0, opacity: 1 }}
          initial={{ y: 50, opacity: 0 }}
          transition={{ duration: 1 }}
          className="text-4xl lg:text-5xl font-semibold"
        >
          Skills
        </motion.h1>
        <div className="py-6 grid md:grid-cols-3 justify-center md:gap-x-8 gap-y-5">
          <img
            src={frontend}
            alt="frontend"
            width={60}
            height={60}
            className="hidden lg:block justify-self-center"
          />
          <img
            src={backend}
            alt="backend gif"
            width={80}
            height={80}
            className="hidden lg:block justify-self-center"
          />
         
          <img
            src={skills}
            alt="miscellaneous"
            width={80}
            height={80}
            className="hidden lg:block justify-self-center"
          />
         
          <div className="w-full flex flex-col h-full text-center bg-slate-100 shadow-lg rounded-xl py-4 px-6">
            <div className="flex items-center w-full justify-center gap-2 pb-4">
              <h1 className="text-2xl font-semibold">Frontend</h1>
              <img
                src={frontend}
                alt="frontend"
                width={28}
                height={28}
                className="lg:hidden"
              />
            </div>
            <ul className="text-lg flex-1 flex flex-col justify-center font-medium text-gray-600">
              <li>HTML</li>
              <li>CSS</li>
              <li>JavaScript</li>
             
              <li>React.js</li>
              <li>Redux Toolkit</li>
              <li>TailwindCSS</li>
             <li>Bootstrap</li>
            </ul>
          </div>
          <div className="w-80 md:w-full flex flex-col text-center justify-self-center bg-slate-100 shadow-md rounded-xl py-4 px-6">
            <div className="flex items-center w-full justify-center gap-2 pb-4">
              <h1 className="text-2xl font-semibold">Backend</h1>
              <img
                src={backend}
                alt="backend gif"
                width={30}
                height={30}
                className="lg:hidden"
              />
            </div>
            <ul className="text-lg flex-1 flex flex-col justify-center font-medium text-gray-600 items-center">
              <li>Node.js</li>
              <li>Express.js</li>
              
              <li>MongoDB</li>
              <li>Mongoose</li>
             
            </ul>
          </div>
          <div className="w-full justify-self-center flex flex-col text-center bg-slate-100 shadow-md rounded-xl py-4 px-6">
            <div className="flex items-center w-full justify-center gap-2 pb-4">
              <h1 className="text-2xl font-semibold">Miscellaneous</h1>
              <img
                src={skills}
                alt="miscellaneous"
                width={30}
                height={30}
                className="md:hidden"
              />
            </div>
            <ul className="text-lg flex-1 flex flex-col justify-center font-medium text-gray-600">
              <li>Java</li>
              <li>Python</li>
              <li>SQL</li>
              <li>GitHub</li>
              <li>Postman</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;